import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/Breadcrumbs/Breadcrumbs.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import clsx from 'clsx';
import { useStoreMap } from 'effector-react';
import { Box } from '@gmini/ui-kit/lib/Box';
import { Home as HomeIcon, ThreeDots, FolderGroup, CubeWithTarget, Folder } from '@gmini/ui-kit';
import { isNotEmpty } from '@gmini/utils';
import { getNode } from "../../../classifier-service";
import { isReferenceNode } from "../../../classifier-service/Node";
import { getClassifierIcon } from "../../Common";
import { NodeExpand } from "../../NodeExpand";
import { CubeWithTargetWrapper } from "../../DependencyTree/nodes/AssemblyClassifierNodeContent.styled";
import { NodeLayout } from "../NodeLayout";
import { buildKeyByPath } from "../utils";
import { BreadcrumbsList } from "./BreadcrumbsList";
import { BreadcrumbsRow } from "./BreadCrumbsRow";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Breadcrumbs = /*#__PURE__*/React.memo(function (_ref) {
  var _clsx;

  var breadCrumbData = _ref.breadCrumbData,
      scrollTo = _ref.scrollTo,
      nodes$ = _ref.nodes$;
  var breadCrumbNodes = useStoreMap({
    store: nodes$,
    keys: [breadCrumbData],
    fn: function fn(nodes, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          breadCrumbData = _ref3[0];

      return breadCrumbData.map(function (_ref4) {
        var item = _ref4.item,
            index = _ref4.index;

        if (item.ref.type === 'LoadMore' || item.ref.type === 'CreateNode') {
          return null;
        }

        var key = buildKeyByPath(item.path);
        var node = getNode(nodes, item.ref);

        if (node && isReferenceNode(node)) {
          node = getNode(nodes, node.element);
        }

        if (!node) {
          return null;
        }

        return {
          name: 'name' in node ? node.name : '',
          item: item,
          index: index,
          key: key
        };
      }).filter(isNotEmpty);
    }
  });
  var classes = useStyles();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      listOpen = _React$useState2[0],
      setListOpen = _React$useState2[1];

  var onClickItem = React.useCallback(function (breadCrumbData, event) {
    if (event) {
      event.preventDefault();
    }

    var currentFlatNode = breadCrumbNodes.find(function (_ref5) {
      var key = _ref5.key;
      return key === breadCrumbData.key;
    });

    if (currentFlatNode) {
      scrollTo(currentFlatNode.index);
      setListOpen(false);
    }
  }, [scrollTo, breadCrumbNodes]);
  var breadcrumbsNodes = breadCrumbNodes.filter(function (_ref6) {
    var key = _ref6.key;
    return key !== breadCrumbNodes[0].key;
  });

  var getModelIcon = function getModelIcon(ref) {
    var _node = getNode(nodes$.getState(), ref);

    var node = (_node === null || _node === void 0 ? void 0 : _node.type) === 'BimModelReferenceNode' ? getNode(nodes$.getState(), _node.element) : _node;
    return (node === null || node === void 0 ? void 0 : node.type) === 'BimModelNode' && node.modelType === 'AssemblyModel' || (node === null || node === void 0 ? void 0 : node.type) === 'AssemblyClassifierNode' ? /*#__PURE__*/_jsx(CubeWithTargetWrapper, {
      children: /*#__PURE__*/_jsx(CubeWithTarget, {})
    }) : /*#__PURE__*/_jsx(HomeIcon, {});
  };

  var rootContent = function rootContent(breadCrumbNode) {
    var item = breadCrumbNode.item,
        name = breadCrumbNode.name;
    var nodeLayoutProps = {
      text: name,
      deepness: 0,
      onClick: function onClick() {
        return onClickItem(breadCrumbNode);
      },
      expandJsx: /*#__PURE__*/_jsx(NodeExpand, {
        expanded: true,
        onClick: function onClick() {
          return onClickItem(breadCrumbNode);
        }
      })
    };

    if (item.ref.type === 'LoadMore' || item.ref.type === 'CreateNode') {
      return null;
    }

    var node = getNode(nodes$.getState(), item.ref);

    if (!node) {
      return null;
    }

    switch (node.type) {
      case 'AnonymousClassifierNode':
      case 'UserClassifierNode':
        return /*#__PURE__*/_jsx(NodeLayout, _objectSpread(_objectSpread({}, nodeLayoutProps), {}, {
          icon: getClassifierIcon(node)
        }));

      case 'AssemblyClassifierNode':
      case 'BimModelReferenceNode':
      case 'BimModelNode':
        {
          return /*#__PURE__*/_jsx(NodeLayout, _objectSpread(_objectSpread({}, nodeLayoutProps), {}, {
            icon: getModelIcon(item.ref)
          }));
        }

      case 'DynamicBaseGroupNode':
        {
          return /*#__PURE__*/_jsx(NodeLayout, _objectSpread(_objectSpread({}, nodeLayoutProps), {}, {
            icon: /*#__PURE__*/_jsx(FolderGroup, {})
          }));
        }

      case 'UserClassifierEmptyGroupNode':
      case 'UserClassifierGroupWithElementsNode':
      case 'UserClassifierGroupWithGroupsNode':
        return /*#__PURE__*/_jsx(NodeLayout, _objectSpread(_objectSpread({}, nodeLayoutProps), {}, {
          icon: /*#__PURE__*/_jsx(Folder, {})
        }));

      default:
        throw new Error("Unexpected type ".concat(item.ref.type, " "));
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    className: classes.root,
    children: [/*#__PURE__*/_jsx(Box, {
      children: breadCrumbNodes[0] && rootContent(breadCrumbNodes[0])
    }), breadcrumbsNodes.length > 0 && /*#__PURE__*/_jsx(BreadcrumbsRow, {
      breadcrumbsNodes: breadcrumbsNodes,
      onItemClick: onClickItem,
      detailsButton: breadcrumbsNodes.length > 1 && /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx("div", {
          className: clsx(classes.collapseButton, (_clsx = {}, _defineProperty(_clsx, classes.listOpened, listOpen), _defineProperty(_clsx, classes.listClosed, !listOpen), _clsx)),
          onClick: function onClick() {
            return setListOpen(true);
          },
          children: /*#__PURE__*/_jsx("div", {
            className: classes.dotsWrapper,
            children: /*#__PURE__*/_jsx(ThreeDots, {})
          })
        })
      })
    }), /*#__PURE__*/_jsx(BreadcrumbsList, {
      open: listOpen,
      onClose: function onClose() {
        return setListOpen(false);
      },
      breadcrumbsNodes: breadcrumbsNodes,
      onListClick: onClickItem
    })]
  });
});
Breadcrumbs.displayName = 'Breadcrumbs';
var useStyles = makeStyles(function () {
  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      zIndex: 999999,
      width: '100%',
      top: 0,
      left: 0,
      boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#fff'
    },
    listOpened: {
      opacity: '1'
    },
    listClosed: {
      opacity: '0.3'
    },
    dotsWrapper: {
      position: 'relative',
      left: '2px'
    },
    collapseButton: {
      marginRight: '3px',
      width: '16px',
      height: '12px',
      background: '#00003D',
      borderRadius: '4px',
      marginBottom: '2px'
    },
    listText: {
      cursor: 'pointer'
    }
  });
});